"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const radio_dispatch_1 = require("@clearsummit/radio-dispatch");
const summithill_models_1 = require("@clearsummit/summithill-models");
const formik_1 = require("formik");
const lodash_1 = require("lodash");
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const components_1 = require("@/components");
const base_form_1 = __importDefault(require("@/components/base-form"));
const buttons_1 = require("@/components/base-form/buttons");
const fields_1 = require("@/components/base-form/fields");
const form_error_1 = __importDefault(require("@/components/base-form/form-error"));
const constants_1 = __importStar(require("@/constants"));
const services_1 = require("@/helpers/services");
const modals_1 = require("@/modals");
const redux_1 = require("@/redux");
const api_payloads_1 = require("@/redux/api-payloads");
const selectors_1 = __importDefault(require("@/selectors"));
const field_names_1 = require("../field-names");
const schemas_1 = require("../schemas");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const CONTENT_OPTIONS = [
    { value: 'VIDEO', label: constants_1.default.managePrograms.create.videoLabel },
    { value: 'PROCESS_QUESTION', label: constants_1.default.managePrograms.create.processQuestionLabel }
];
const SECTION_OPTIONS = [
    { value: 'SESSION', label: constants_1.default.managePrograms.create.sectionTypeSession },
    { value: 'CONTENT_SECTION', label: constants_1.default.managePrograms.create.sectionTypeContent },
];
const SESSION_OPTIONS = [
    { value: 'THERAPY', label: constants_1.default.managePrograms.create.sessionTypeTherapy },
    { value: 'CASE_MANAGEMENT', label: constants_1.default.managePrograms.create.sessionTypeCaseManagement },
];
const QUESTION_KEYS = ['wording', 'placeholder', 'order', 'id'];
const PROCESS_QUESTION_KEYS = ['questions', 'order', 'name', 'id', 'content_type'];
const VIDEO_KEYS = ['name', 'url', 'duration', 'order', 'id', 'content_type'];
const SESSION_KEYS = ['program', 'session_type', 'section_type', 'name', 'order', 'id'];
const CONTENT_SECTION_KEYS = ['program', 'contents', 'section_type', 'name', 'order', 'id'];
// @ts-ignore
const NEW_CONTENT = { content_type: '', name: '', url: '', duration: '', questions: [] };
const QuestionForm = ({ question, index, contentIndex, onRemove, dragRef = null }) => {
    const { values, setFieldValue } = formik_1.useFormikContext();
    const questionName = `contents[${contentIndex}].questions[${index}]`;
    React.useEffect(() => {
        const questionField = `${questionName}.order`;
        if (lodash_1.get(values, questionField) !== index) {
            setFieldValue(questionField, index);
        }
    }, [index]);
    return (React.createElement("div", { className: styles_scss_1.default.question },
        React.createElement("img", { ref: dragRef, src: constants_1.Images.drag, alt: "drag", className: styles_scss_1.default.moveIcon }),
        (question === null || question === void 0 ? void 0 : question.id) && React.createElement(formik_1.Field, { name: `${questionName}.id`, type: "hidden" }),
        React.createElement(formik_1.Field, { name: `${questionName}.order`, type: "hidden" }),
        React.createElement(formik_1.Field, { name: `${questionName}.wording` }, ({ field, form }) => (React.createElement(components_1.Input, Object.assign({}, field, { placeholder: constants_1.default.managePrograms.create.question, label: constants_1.default.managePrograms.create.question, 
            // @ts-ignore
            error: lodash_1.get(form, `errors[${field.name}]`, undefined), numberOfLines: 1, multiline: true, required: true })))),
        React.createElement(formik_1.Field, { name: `${questionName}.placeholder` }, ({ field, form }) => (React.createElement(components_1.Input, Object.assign({}, field, { placeholder: constants_1.default.managePrograms.create.questionPlaceholder, label: constants_1.default.managePrograms.create.questionPlaceholder, 
            // @ts-ignore
            error: lodash_1.get(form, `errors[${field.name}]`, undefined) })))),
        React.createElement(components_1.Button, { className: styles_scss_1.default.deleteButton, variant: "transparent", ariaLabel: constants_1.default.managePrograms.create.delete, title: constants_1.default.managePrograms.create.delete, imgUrls: { default: constants_1.Images.trash, selected: constants_1.Images.trash }, onClick: () => onRemove(index) })));
};
const ProcessQuestionForm = ({ index, onRemove }) => {
    const { values, validateForm } = formik_1.useFormikContext();
    // @ts-ignore
    const content = values.contents[index];
    React.useEffect(() => {
        if (content.questions.length === 0) {
            onRemove(index);
        }
    }, [content]);
    return (React.createElement("div", { className: styles_scss_1.default.processQuestionContainer },
        React.createElement(formik_1.FieldArray, { name: `contents[${index}].questions`, render: (arrayHelpers) => {
                const onRemoveQuestion = (idx) => arrayHelpers.remove(idx);
                const onReorderQuestions = (idx, atIndex) => {
                    const step = idx - atIndex > 0 ? -1 : 1;
                    for (let i = idx; i !== atIndex; i += step) {
                        arrayHelpers.swap(i, i + step);
                    }
                    validateForm();
                };
                return (React.createElement(React.Fragment, null,
                    React.createElement(components_1.DraggableList, { className: styles_scss_1.default.processQuestions, 
                        // @ts-ignore
                        items: values.contents[index].questions, render: (item, idx) => (React.createElement(QuestionForm, { index: idx, contentIndex: index, onRemove: onRemoveQuestion, question: item })), onChangeIndex: onReorderQuestions }),
                    React.createElement("div", { className: styles_scss_1.default.addNewQuestion },
                        React.createElement(components_1.Button, { variant: "transparent", ariaLabel: "add", imgUrls: {
                                default: constants_1.Images.plus,
                                selected: constants_1.Images.plus
                            }, title: constants_1.default.managePrograms.create.addNewQuestion, onClick: () => arrayHelpers.push(new summithill_models_1.Question()) }))));
            } })));
};
const VideoForm = ({ index, onRemove }) => (React.createElement("div", { className: styles_scss_1.default.videoContainer },
    React.createElement(formik_1.Field, { name: `contents[${index}].name` }, ({ field, form }) => (React.createElement(components_1.Input, Object.assign({}, field, { placeholder: constants_1.default.managePrograms.create.videoName, label: constants_1.default.managePrograms.create.videoName, 
        // @ts-ignore
        error: lodash_1.get(form, `errors[${field.name}]`, undefined), required: true })))),
    React.createElement(formik_1.Field, { name: `contents[${index}].url` }, ({ field, form }) => (React.createElement(components_1.Input, Object.assign({}, field, { placeholder: constants_1.default.managePrograms.create.videoUrl, label: constants_1.default.managePrograms.create.videoUrl, 
        // @ts-ignore
        error: lodash_1.get(form, `errors[${field.name}]`, undefined), required: true })))),
    React.createElement(formik_1.Field, { name: `contents[${index}].duration` }, ({ field, form }) => (React.createElement(components_1.Input, Object.assign({}, field, { placeholder: constants_1.default.managePrograms.create.videoDurationPlaceholder, label: constants_1.default.managePrograms.create.videoDuration, 
        // @ts-ignore
        error: lodash_1.get(form, `errors[${field.name}]`, undefined), required: true })))),
    React.createElement(components_1.Button, { className: styles_scss_1.default.deleteButton, variant: "transparent", ariaLabel: constants_1.default.managePrograms.create.delete, title: constants_1.default.managePrograms.create.delete, imgUrls: { default: constants_1.Images.trash, selected: constants_1.Images.trash }, onClick: () => { onRemove(index); } })));
const ContentForm = ({ index, onRemove, dragRef = null }) => {
    const { values, setFieldValue } = formik_1.useFormikContext();
    // @ts-ignore
    const content = values.contents[index];
    React.useEffect(() => {
        const orderField = `contents[${index}].order`;
        if (lodash_1.get(values, orderField) !== index) {
            setFieldValue(orderField, index);
        }
    }, [index]);
    return (React.createElement("div", { className: styles_scss_1.default.stepItem },
        React.createElement("div", { className: styles_scss_1.default.contentTypeContainer },
            React.createElement("img", { ref: dragRef, src: constants_1.Images.drag, alt: 'drag', className: styles_scss_1.default.moveIcon }),
            React.createElement("div", { className: styles_scss_1.default.contentType },
                React.createElement(formik_1.Field, { name: `contents[${index}].content_type` }, ({ field, form }) => {
                    // @ts-ignore
                    const { value } = field;
                    return (
                    // @ts-ignore
                    React.createElement(components_1.Dropdown, Object.assign({ options: CONTENT_OPTIONS }, field, { value: lodash_1.find(CONTENT_OPTIONS, { value }), placeholder: constants_1.default.managePrograms.create.selectStep, 
                        /* eslint-disable */
                        onChange: (value, action) => {
                            //@ts-ignore
                            const contentType = value === null || value === void 0 ? void 0 : value.value;
                            if (action.action === 'select-option') {
                                //@ts-ignore
                                form.setFieldValue(field.name, contentType);
                                if (contentType === 'VIDEO') {
                                    //@ts-ignore
                                    form.setFieldValue(`contents[${index}].questions`, []);
                                }
                                else if (contentType === 'PROCESS_QUESTION') {
                                    //@ts-ignore
                                    form.setFieldValue(`contents[${index}].questions`, [new summithill_models_1.Question()]);
                                    //@ts-ignore
                                    form.setFieldValue(`contents[${index}].name`, '');
                                    //@ts-ignore
                                    form.setFieldValue(`contents[${index}].url`, '');
                                    //@ts-ignore
                                    form.setFieldValue(`contents[${index}].duration`, '');
                                }
                            }
                        }, 
                        /* eslint-enable */
                        // @ts-ignore
                        error: lodash_1.get(form, `errors.[${field.name}]`, undefined) })));
                }),
                React.createElement(formik_1.Field, { name: `contents[${index}].order`, type: "hidden" }),
                (content === null || content === void 0 ? void 0 : content.content_type) === 'PROCESS_QUESTION' && (React.createElement(formik_1.Field, { name: `contents[${index}].name` }, ({ field, form }) => (React.createElement(components_1.Input, Object.assign({}, field, { placeholder: constants_1.default.managePrograms.create.processQuestionPlaceholder, label: constants_1.default.managePrograms.create.processQuestionPlaceholder, 
                    // @ts-ignore
                    error: lodash_1.get(form, `errors[${field.name}]`, undefined), required: true }))))))),
        React.createElement("div", { className: styles_scss_1.default.stepInfo },
            (content === null || content === void 0 ? void 0 : content.content_type) === 'VIDEO' && React.createElement(VideoForm, { index: index, onRemove: onRemove }),
            (content === null || content === void 0 ? void 0 : content.content_type) === 'PROCESS_QUESTION' && React.createElement(ProcessQuestionForm, { index: index, onRemove: onRemove }))));
};
/* eslint-disable max-lines */
// eslint-disable-next-line max-lines-per-function
const SectionForm = ({ pendingProgram, pendingSection, section, order, dragRef = null, expanded, onExpand, deleteSection }) => {
    const { values, setFieldValue, dirty, submitForm, errors, validateForm } = formik_1.useFormikContext();
    const [toSave, setToSave] = React.useState(false);
    React.useEffect(() => {
        if (lodash_1.get(values, 'order') !== order) {
            setFieldValue('order', order);
        }
    }, [order]);
    React.useEffect(() => {
        if (pendingProgram && dirty && lodash_1.isEmpty(errors)) {
            setToSave(true);
        }
    }, [pendingProgram]);
    React.useEffect(() => {
        if (!pendingSection && toSave) {
            submitForm();
            setToSave(false);
        }
    }, [pendingSection, toSave]);
    const expandIcon = expanded ? constants_1.Images.accordionAngleUp : constants_1.Images.accordionAngleDown;
    const expandMessage = expanded ? constants_1.default.managePrograms.create.collapse : constants_1.default.managePrograms.create.expand;
    return (React.createElement("div", { className: styles_scss_1.default.sectionItem },
        React.createElement("div", { className: styles_scss_1.default.sectionHeader },
            React.createElement("img", { ref: dragRef, src: constants_1.Images.drag, alt: 'drag', className: styles_scss_1.default.moveIcon }),
            React.createElement(fields_1.TextInputField, { name: field_names_1.SectionCreateFieldNames.name, placeholder: constants_1.default.managePrograms.create.name }),
            React.createElement(fields_1.DropdownInputField, { className: styles_scss_1.default.dropdownInputField, name: field_names_1.SectionCreateFieldNames.type, options: SECTION_OPTIONS, placeholder: constants_1.default.managePrograms.create.selectSection }),
            lodash_1.get(values, field_names_1.SectionEditFieldNames.id) && React.createElement(formik_1.Field, { type: "hidden", name: field_names_1.SectionEditFieldNames.id }),
            React.createElement(formik_1.Field, { type: "hidden", name: field_names_1.SectionCreateFieldNames.order, value: order }),
            React.createElement(formik_1.Field, { type: "hidden", name: field_names_1.SectionCreateFieldNames.program, value: section === null || section === void 0 ? void 0 : section.program }),
            React.createElement(components_1.Button, { variant: "transparent", ariaLabel: expandMessage, imgUrls: { default: expandIcon, selected: expandIcon }, title: expandMessage, onClick: onExpand }),
            React.createElement(buttons_1.SubmitButton, { disableOnErrors: true, title: "Save", className: styles_scss_1.default.sectionSaveButton })),
        expanded && lodash_1.get(values, field_names_1.SectionCreateFieldNames.type) === 'CONTENT_SECTION' && (React.createElement("div", { className: styles_scss_1.default.steps },
            React.createElement(formik_1.FieldArray, { name: "contents", render: (arrayHelpers) => {
                    const onRemoveContent = (index) => arrayHelpers.remove(index);
                    const onReorderContents = (index, atIndex) => {
                        const step = index - atIndex > 0 ? -1 : 1;
                        for (let i = index; i !== atIndex; i += step) {
                            arrayHelpers.swap(i, i + step);
                        }
                        validateForm();
                    };
                    return (React.createElement(React.Fragment, null,
                        React.createElement(components_1.DraggableList, { className: styles_scss_1.default.steps, 
                            // @ts-ignore
                            items: values.contents || [], render: (item, index) => React.createElement(ContentForm, { key: item === null || item === void 0 ? void 0 : item.id, index: index, onRemove: onRemoveContent }), onChangeIndex: onReorderContents }),
                        React.createElement("div", { className: styles_scss_1.default.addButton },
                            React.createElement(components_1.Button, { variant: "transparent", ariaLabel: "add", imgUrls: {
                                    default: constants_1.Images.plus,
                                    selected: constants_1.Images.plus
                                }, title: constants_1.default.managePrograms.create.addNewStep, onClick: () => arrayHelpers.push(NEW_CONTENT) }))));
                } }))),
        expanded && lodash_1.get(values, field_names_1.SectionCreateFieldNames.type) === 'SESSION' && (React.createElement("div", { className: styles_scss_1.default.sessionContainer },
            React.createElement(fields_1.DropdownInputField, { className: styles_scss_1.default.sessionDropdown, name: field_names_1.SectionCreateFieldNames.sessionType, options: SESSION_OPTIONS, placeholder: constants_1.default.managePrograms.create.selectSession }))),
        React.createElement(form_error_1.default, { className: styles_scss_1.default.formError, formKey: services_1.endpoints.createSection, metaValidation: (meta) => (meta === null || meta === void 0 ? void 0 : meta.order) === order }),
        React.createElement(components_1.Button, { className: styles_scss_1.default.deleteSectionButton, variant: "transparent", title: constants_1.default.managePrograms.create.deleteThisSection, ariaLabel: constants_1.default.managePrograms.create.deleteThisSection, imgUrls: { default: constants_1.Images.trashRed, selected: constants_1.Images.trashRed }, onClick: () => {
                components_1.modalEvents.setAndRender(modals_1.ModalNames.SECTION_DELETE, React.createElement(modals_1.SectionDeleteModal, { sectionName: section === null || section === void 0 ? void 0 : section.name, onDelete: () => {
                        deleteSection({ id: section === null || section === void 0 ? void 0 : section.id, sectionName: section === null || section === void 0 ? void 0 : section.name, order });
                    } }));
            } })));
};
const SectionParentForm = (_a) => {
    var { section, adminSection, clearAdminSection } = _a, rest = __rest(_a, ["section", "adminSection", "clearAdminSection"]);
    const [initialValues, setInitialValues] = React.useState(section);
    React.useEffect(() => {
        if ((adminSection === null || adminSection === void 0 ? void 0 : adminSection.order) === (rest === null || rest === void 0 ? void 0 : rest.order)) {
            setInitialValues(adminSection);
            clearAdminSection(rest === null || rest === void 0 ? void 0 : rest.order);
        }
    }, [adminSection]);
    return (React.createElement(base_form_1.default, { initialValues: initialValues, validationSchema: schemas_1.sectionCreateSchema, formKey: (section === null || section === void 0 ? void 0 : section.id) ? services_1.endpoints.editSection : services_1.endpoints.createSection, onSubmitPayload: (payload) => {
            const sectionPayload = Object.keys(payload)
                .filter(key => ((payload.section_type === 'SESSION' && SESSION_KEYS.includes(key) ||
                payload.section_type === 'CONTENT_SECTION' && CONTENT_SECTION_KEYS.includes(key)) && (key !== 'id' || !!lodash_1.get(payload, 'id'))))
                .reduce((obj, key) => {
                // eslint-disable-next-line no-param-reassign
                obj[key] = lodash_1.get(payload, key);
                return obj;
            }, {});
            if (lodash_1.get(sectionPayload, 'section_type') === 'CONTENT_SECTION') {
                const contents = lodash_1.get(sectionPayload, 'contents') || [];
                sectionPayload.contents = contents.map((content, index) => {
                    const contentPayload = Object.keys(content)
                        .filter((key) => ((content.content_type === 'VIDEO' && VIDEO_KEYS.includes(key) ||
                        content.content_type === 'PROCESS_QUESTION' && PROCESS_QUESTION_KEYS.includes(key)) && (key !== 'id' || !!lodash_1.get(content, 'id'))))
                        .reduce((obj, key) => {
                        // eslint-disable-next-line no-param-reassign
                        obj[key] = lodash_1.get(content, key);
                        if (key === 'order') {
                            // eslint-disable-next-line no-param-reassign
                            obj.order = index;
                        }
                        return obj;
                    }, {});
                    if (lodash_1.get(contentPayload, 'content_type') === 'PROCESS_QUESTION') {
                        contentPayload.questions = (lodash_1.get(contentPayload, 'questions') || [])
                            .map((question, questionIndex) => Object.keys(question)
                            .filter(key => QUESTION_KEYS.includes(key) && (key !== 'id' || !!lodash_1.get(question, 'id')))
                            .reduce((obj, key) => {
                            // eslint-disable-next-line no-param-reassign
                            obj[key] = lodash_1.get(question, key);
                            if (key === 'order') {
                                // eslint-disable-next-line no-param-reassign
                                obj.order = questionIndex;
                            }
                            return obj;
                        }, {}));
                    }
                    return contentPayload;
                });
            }
            return lodash_1.get(sectionPayload, field_names_1.SectionEditFieldNames.id)
                ? api_payloads_1.editSectionPayload(sectionPayload)
                : api_payloads_1.createSectionPayload(sectionPayload);
        } },
        React.createElement(SectionForm, Object.assign({ section: section }, rest))));
};
const stateProps = (state) => ({
    pendingProgram: radio_dispatch_1.selectors.getPending(state, services_1.endpoints.editProgram),
    pendingSection: radio_dispatch_1.selectors.getPending(state, services_1.endpoints.createSection) || radio_dispatch_1.selectors.getPending(state, services_1.endpoints.editSection),
    adminSection: selectors_1.default.program.getAdminSection(state)
});
const dispatchProps = ({
    clearAdminSection: (order) => redux_1.ActionCreators.program.clearAdminSection.dispatch(order)
});
exports.default = react_redux_1.connect(stateProps, dispatchProps)(SectionParentForm);
